import { JSX } from "react";
import Chip from "@mui/material/Chip";
import { AccessLevel, Resource, ResourceType, Scope } from "./general";

export interface IMarketplaceAccessResource {
  rawText?: string;
  accessLevel?: string;
  scope?: string;
  isDisabled?: boolean;
}

export class MarketplaceAccess extends Resource {
  public readonly resourceType: ResourceType = ResourceType.MarketplaceAccess;
  public accessLevel?: AccessLevel;
  public scope?: Scope;
  public rawText?: string;

  public get metaText(): string {
    return `marketplace ${this.accessLevel} ${this.scope}`;
  }

  public asJSXElement(): JSX.Element {
    return <Chip label={<><strong>Marketplace</strong><span>
      {`: ${this.scope} (${this.accessLevel})`}</span></>} />;
  }

  public override toString(): string {
    return `Marketplace: ${this.scope} (${this.accessLevel})`;
  }

  public fromObject(obj: IMarketplaceAccessResource): Resource {
    const resource = new MarketplaceAccess();
    resource.rawText = obj.rawText || "";
    resource.accessLevel = AccessLevel[obj.accessLevel as keyof typeof AccessLevel];
    resource.scope = Scope[obj.scope as keyof typeof Scope];
    resource.isDisabled = !!obj.isDisabled;
    return resource;
  }

  public toJSONString(): string {
    return JSON.stringify({
      resourceType: ResourceType[this.resourceType],
      accessLevel: typeof this.accessLevel === 'string' ? AccessLevel[this.accessLevel] : this.accessLevel,
      scope: typeof this.scope === 'string' ? Scope[this.scope] : this.scope,
      isDisabled: this.isDisabled
    });
  }

  public static getPermutations(): MarketplaceAccess[] {
    const fieldIterations: [key: string, value: string[]][] = [
      ['accessLevel', Object.keys(AccessLevel).filter((key) => Number.isNaN(Number(key)))],
      ['scope', Object.keys(Scope).filter((key) => Number.isNaN(Number(key)))],
    ];
    return this.generatePermutations(MarketplaceAccess, fieldIterations) as MarketplaceAccess[];
  }
}
